let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("hujhN")).then(() => parcelRequire('c8bxg'));